import React, { useState, useMemo, useEffect } from "react";
import { useIntl } from "umi";
import { Modal, Bubble, Form, Button, Checkbox, Row, Col } from "tea-component";
import SvgIcon from '@/pages/home/components/SvgIcon';
import { useLocalOptions, useSortValue } from "@/pages/dashboard/utils/customHook";
import "./index.scss";

export const defaultStatisticsTypeOptionValues = ["sum", "avg_no_null", "avg_no_null_zero", "max", "min", "count"];
export const defaultStatisticsTypeValue = ["sum", "avg_no_null"];

export function uniqueArray<T>(arr: Array<T>) {
  return Array.from(new Set(arr));
}

// 对比两个数组是否相同
export function compareArraysEqual<T>(arr1: Array<T>, arr2: Array<T>) {
  // 两边随便谁不存在，都代表不相同
  if (!arr1 || !arr2) {
    return false;
  }

  arr1 = uniqueArray(arr1);
  arr2 = uniqueArray(arr2);

  // 如果长度不同，那肯定就不同
  if (arr1.length !== arr2.length) {
    return false;
  }
  // 排序后进行比较，保证所有元素是在同一个位置
  arr1.sort();
  arr2.sort();

  return arr1.some((item, index) => {
    const a2 = arr2[index];
    return item === a2;
  });
}

function MetricsSettings(props: any) {
  const {
    settingId,
    onConfirm,
    onCancel,
    metricOptions = [],
    disabledOptions = [],
    statisticsTypeOptions,
    defaultStatisticsType = defaultStatisticsTypeValue,
    getUpdated = false,
    showMetrics,
    showTypeOptions = true, // 显示自定义统计指标？
    requireItem = false, // 至少选择一项
  } = props;
  const { formatMessage } = useIntl();
  const [visible, setVisible] = useState(false);

  // 自定义指标
  const allValues = useMemo(() => metricOptions.map((opt) => opt.value), [metricOptions]);
  const [metricValues, setMetricValues] = useState<string[]>(allValues);

  useEffect(() => {
    // 检测是否传入showMetrics，不涉及其他页面逻辑
    if (showMetrics && !compareArraysEqual(metricValues, showMetrics)) {
      setMetricValues(showMetrics);
    }
  }, [showMetrics?.join(', ')]);

  useEffect(() => {
    if (getUpdated) {
      setMetricValues(allValues);
    }
  }, [allValues]);

  // 统计值展示类型
  const [statisticsType, setStatisticsType] = useState(defaultStatisticsType);
  const typeOptions = statisticsTypeOptions ? statisticsTypeOptions : useLocalOptions(defaultStatisticsTypeOptionValues);
  const sortStatisticsValue = useSortValue(typeOptions);
  const sortMetricsValue = useSortValue(metricOptions);

  return (
    <>
      <div className='overall-conext-item js-overview-table-setting' onClick={() => setVisible(true)}>
        <Bubble
          dark
          placement="top"
          content={formatMessage({ id: 'overview_Setting' })}
        >
          <span id={settingId} onClick={() => setVisible(true)}><SvgIcon className='overall-conext-icon' type='set-up' /></span>
        </Bubble>
      </div>
      <Modal
        className="metrics-setting-modal"
        visible={visible}
        onClose={() => {
          onCancel?.();
          setVisible(false);
        }}
        caption={formatMessage({ id: 'metrics_setting_title' })}
        size="xl"
      >
        <Modal.Body>
          <Form>
            <Form.Item label={formatMessage({ id: "metrics_setting_show_metrics" })}>

              <Checkbox.Group className="dbd-check-list down-group" value={metricValues} onChange={value => setMetricValues(value)}>
                <Row>
                  <Col span={6}>
                    <Checkbox
                      display="block"
                      name="all"
                      indeterminate={metricValues.length !== 0 && metricValues.length !== metricOptions.length}
                      onChange={(value) => {
                        value ? setMetricValues(allValues) : setMetricValues([]);
                      }}
                      value={metricValues.length === metricOptions.length}
                    >
                      {formatMessage({ id: "common_all" })}
                    </Checkbox>
                  </Col>
                  {
                    disabledOptions.map((opt, index) => (<Col key={index} span={6}><Checkbox disabled key={opt.value} value>{opt.text}</Checkbox></Col>))
                  }

                  {
                    metricOptions.map((opt, index) => (<Col key={index} span={6}><Checkbox key={opt.value} name={opt.value}>{opt.text}</Checkbox></Col>))
                  }
                </Row>
              </Checkbox.Group>
            </Form.Item>

            {showTypeOptions && <Form.Item label={formatMessage({ id: "metrics_setting_show_more_statistics" })}>
              <div className="show-more-statistics-tip tea-text-label margin-b-20">{formatMessage({ id: "metrics_setting_show_more_statistics_tips" })}</div>
              <Checkbox.Group
                className='down-group'
                value={statisticsType}
                onChange={(value) => {
                  setStatisticsType(value);
                }}
                layout="column"
              >
                <Row className='metrics-settings-box'>
                  {/* <List type="option"> */}
                  {
                    typeOptions?.map?.((opt, index) => (
                      <Col key={index} span={24}><Checkbox name={opt.value}>{opt.text}</Checkbox></Col>
                    ))
                  }
                </Row>
                {/* </List> */}
              </Checkbox.Group>
            </Form.Item>}
          </Form>

        </Modal.Body>
        <Modal.Footer>
          <Button type="primary" disabled={requireItem ? metricValues.length === 0 : false} onClick={() => {
            onConfirm?.({ metricValues: sortMetricsValue(metricValues), statisticsType: sortStatisticsValue(statisticsType) });
            setVisible(false);
          }}>
            {formatMessage({ id: "common_confirm" })}
          </Button>
          <Button type="weak" onClick={() => {
            onCancel?.();
            setVisible(false);
          }}>
            {formatMessage({ id: "common_cancel" })}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default MetricsSettings;


